import { Injectable } from '@angular/core'
import { AppLoaderService } from '../app-loader/app-loader.service'
import { AppMessageService } from '../app-message/app-message.service'
import { constUrpi, error, urpiweb } from 'app/shared/helpers/constants';
import { MsAdalAngular6Service } from 'microsoft-adal-angular6'
import { AppConfirmService } from '../app-confirm/app-confirm.service';
import { numberOnly, aplphaNumberOnly, exceedSizeFile, letterOnly } from 'app/shared/helpers/utils';
import { AppLoadFileService } from '../app-load-file/app-load-file.service';
import { MatSnackBar } from '@angular/material';
import { Pagination } from 'app/shared/models/pagination';
import { isEmptyCollection, getMomentDate } from 'app/shared/helpers/utils';
import { LogAuditoria } from 'app/model/log-auditoria';
import { GraphqlLogAuditoriaService } from 'app/service/graphql-log-auditoria.service';

@Injectable()
export class HelperService {

  constructor(
    private _appLoaderService: AppLoaderService,
    private _messageService: AppMessageService,
    private _adalSvc: MsAdalAngular6Service,
    private _appConfirmService: AppConfirmService,
    private _appLoadFileService: AppLoadFileService,
    private _snack: MatSnackBar,
    private _graphqlLogAuditoriaService: GraphqlLogAuditoriaService
  ) { 
  }

  observableError(err: any): void {
    console.log(err)
    this._appLoaderService.hide()
    if (err) {
      if (!err.networkError) {
        this.openMessage(error.message.generic, constUrpi.typeMessageDialog.ERROR);
      } else {
        switch (err.networkError.status) {
          case 401:
            this.openMessage(error.message.session, constUrpi.typeMessageDialog.SESSION).then(res => {
              this.closeSession();
            });
            break;
          case 400:
            this.openMessage(error.message.generic, constUrpi.typeMessageDialog.ERROR);
            break;
          case 403:
            this.openMessage(error.message.generic, constUrpi.typeMessageDialog.ERROR);
            break;
          case 500:
            this.openMessage(error.message.generic, constUrpi.typeMessageDialog.ERROR);
            break;
          default:
            this.openMessage(error.message.generic, constUrpi.typeMessageDialog.ERROR);
        }
      }
    } else {
      this.openMessage(error.message.generic, constUrpi.typeMessageDialog.ERROR);
    }
  }

  closeSession() {
    this._adalSvc.logout();
    this.removeStorageAll();
  }

  isStatusOk(data: any): boolean {
    let respueta = false;
    if (data.status == error.statusResponse.OK) {
      respueta = true;
    }
    return respueta;
  }

  isLoginValid(data: any): boolean {
    let respueta = false;
    if (data.status == error.statusResponse.OK) {
      respueta = true;
    }
    return respueta;
  }
  

  openMessage(message: string, type?: number): any {
    if (type == undefined || type == null) {
      type = constUrpi.typeMessageDialog.WARNING
    }
    return this._messageService.open({ message: message, type: type });
  }

  openConfirmer(message: string, title?: string): any {
    return this._appConfirmService.confirm({ message: message, title: title });
  }

  textType(event: any, type: string): boolean {
    if (type == 'number') {
      return numberOnly(event);
    } else if (type == 'aplphanumber') {
      return aplphaNumberOnly(event);
    } else if (type == 'aplpha') {
      return letterOnly(event);
    }
  }

  openLoadFile(): any {
    return this._appLoadFileService.open();
  }

  openSnackLoading(mensaje: string): any {
    return this._snack.open(mensaje, null,
      {
        duration: 4000,
        verticalPosition: 'bottom',
        horizontalPosition: 'right',
        panelClass: ["snack_warning"]
      }  
    )
   }

  openSnackOk(mensaje: string): any {
    return this.openSnack(mensaje, "snack_ok");
  }

  openSnackError(mensaje: string): any {
    return this.openSnack(mensaje, "snack_error");
  }

  openSnackWarning(mensaje: string): any {
    return this.openSnack(mensaje, "snack_warning");
  }

  openSnack(mensaje: string, panel_class: string): any {
    return this._snack.open(mensaje, null,
      {
        duration: 4000,
        verticalPosition: 'bottom',
        horizontalPosition: 'right',
        panelClass: [panel_class]
      }
    )
  }

  restartPage(paginacion: Pagination, list: any [], totalRecords: any, pageNumber: any): Pagination {
    paginacion.rows = list;
    paginacion.count = totalRecords;
    paginacion.offset = pageNumber - 1;
    if(paginacion.count == 0) {
      paginacion.message = "No hay registros disponibles.";
    }
    return paginacion;
  }

  isEmptyCollection(list: any): boolean {
    return isEmptyCollection(list);
  }

  exceedSizeFile(file, size): boolean {
    return exceedSizeFile(file, size);
  }

  sentScreenJsonLogAuditoria(pantalla: string): any {
    return this.sentEventJsonLogAuditoria(pantalla, "ENTRAR_A_PANTALLA");
  }

  sentEventJsonLogAuditoria(pantalla: string, operacion: string, extraInfo?: any): any {
    if(!extraInfo) {
      extraInfo = null;
    }
    return this.getLogAditoria(pantalla, operacion, extraInfo);
  }

  getLogAditoria(pantalla: string, operacion: string, extraInfo: any): any {
    let fichaUsuario = this.getItemSessionStorage("fichaUsuario");
    let coordenadaXY = this.getItemSessionStorage("coordenadaXY");

    let logAditoria = new LogAuditoria(); 
    logAditoria.codigoUsuario = fichaUsuario.codigoUsuario;
    logAditoria.nombreUsuario = fichaUsuario.nombreUsuario;
    logAditoria.agencia = fichaUsuario.codigoAgencia;
    logAditoria.codigoCliente = null;
    logAditoria.operacion = operacion;
    logAditoria.pantalla = pantalla;
    logAditoria.fechaHora = getMomentDate(new Date(), 'YYYY-MM-DD HH:mm:ss');
    logAditoria.imei = null;
    logAditoria.latitud = (coordenadaXY ? coordenadaXY.latitud : null);
    logAditoria.longitud = (coordenadaXY ? coordenadaXY.longitud : null);
    logAditoria.extraInfo = (extraInfo ? JSON.stringify(extraInfo): extraInfo);
    logAditoria.version = urpiweb.auth.versionApp;
    logAditoria.canalDistribucion = "WEB";
    logAditoria.aplicacionId = constUrpi.aplicacionId;

    let contenedorDatosAnalitica: any = {};
    contenedorDatosAnalitica.listaLogAuditoria = [];
    contenedorDatosAnalitica.listaLogAuditoria.push(JSON.stringify(logAditoria));
    let jsonLog =  JSON.stringify(contenedorDatosAnalitica);
  
    return new Promise(resolve=> {   
      this._graphqlLogAuditoriaService.getDatosAnalitica(jsonLog).subscribe(
        res => {
          resolve(true);
        }, err => { 
          console.log(err); 
          resolve(false);
        }
      )
    });
  }    

  getItemSessionStorage(key: string): any {
    return JSON.parse(sessionStorage.getItem(key));
  }

  getItemSessionStorageR(key: string): any {
    let value = JSON.parse(sessionStorage.getItem(key));
    sessionStorage.removeItem(key);
    return value;
  }

  setItemSessionStorage(key: string, value: any): any {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  removeStorageAll() {
    sessionStorage.clear();
  }
}
